<!--
 * @Description: 系统设置域名配置
 * @Author: xu wei
 * @Date: 2020-03-01 16:11:52
 * @LastEditTime: 2020-06-07 16:33:20
 * @LastEditors: gao shuai
 -->
<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>系统设置</el-breadcrumb-item>
        <el-breadcrumb-item>域名配置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="gs_tablestyle1">
      <div class="gs_title">域名配置</div>
      <div class="addtable">
        <div class="tabletit"><span>充值域名：</span></div>
        <div class="tablebox">
          <table>
            <thead>
              <tr>
                <th width="50">默认</th>
                <th>线路名称</th>
                <th>充值域名</th>
                <th width="100">端口</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,i) in data0" :key="'charge'+i">
                <td>
                  <span class="gs_rido" :class="{'checked':item.isDefault,'disable':item.addself}" @click="changedefault0(item)"></span>
                </td>
                <td>
                  <el-input size="small" v-model="item.name" placeholder="线路名称"></el-input>
                </td>
                <td>
                  <el-input size="small" v-model="item.domainName" placeholder="名称"></el-input>
                </td>
                <td>
                  <el-input size="small" v-model="item.port" @input="item.port=intNumber(item.port)" placeholder="端口"></el-input>
                </td>
                <td>
                  <el-button size="small" type="info" @click="saveclick0(item)">保存</el-button>
                  <el-button size="small" type="info" @click="test(item)">测试链接</el-button>
                  <el-button size="small" type="danger" :disabled="item.isDefault" @click="handleClose0(item,i)">移除路线</el-button>
                </td>
              </tr>
            </tbody>
          </table>
          <p class="tc pdt5 pdb5">
            <el-button size="small" type="primary" @click="add0">添加</el-button>
          </p>
        </div>
      </div>
    </div>
    <div class="gs_tablestyle1 mgt15">
      <div class="addtable">
        <div class="tabletit"><span>商户域名：</span></div>
        <div class="tablebox">
          <table>
            <thead>
              <tr>
                <th width="50">默认</th>
                <th>线路名称</th>
                <th>商户域名</th>
                <th width="100">端口</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,i) in data1" :key="'merchat'+i">
                <td>
                  <span class="gs_rido" :class="{'checked':item.isDefault,'disable':item.addself}" @click="changedefault1(item)"></span>
                </td>
                <td>
                  <el-input size="small" v-model="item.name" placeholder="线路名称"></el-input>
                </td>
                <td>
                  <el-input size="small" v-model="item.domainName" placeholder="名称"></el-input>
                </td>
                <td>
                  <el-input size="small" type="number" v-model="item.port" @input="item.port=intNumber(item.port)" placeholder="端口"></el-input>
                </td>
                <td>
                  <el-button size="small" type="info" @click="saveclick1(item)">保存</el-button>
                  <el-button size="small" type="info" @click="test(item)">测试链接</el-button>
                  <el-button size="small" type="danger" :disabled="item.isDefault" @click="handleClose1(item,i)">移除路线</el-button>
                </td>
              </tr>
            </tbody>
          </table>
          <p class="tc pdt5 pdb5">
            <el-button size="small" type="primary" @click="add1">添加</el-button>
          </p>
        </div>
      </div>
    </div>
    <div class="gs_tablestyle1 mgt15">
      <div class="addtable">
        <div class="tabletit"><span>IPS统计域名：</span></div>
        <div class="tablebox">
          <table>
            <thead>
              <tr>
                <th width="50">默认</th>
                <th>线路名称</th>
                <th>IPS统计域名</th>
                <th width="100">端口</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,i) in data2" :key="'charge'+i">
                <td>
                  <span class="gs_rido" :class="{'checked':item.isDefault,'disable':item.addself}" @click="changedefault2(item)"></span>
                </td>
                <td>
                  <el-input size="small" v-model="item.name" placeholder="线路名称"></el-input>
                </td>
                <td>
                  <el-input size="small" v-model="item.domainName" placeholder="名称"></el-input>
                </td>
                <td>
                  <el-input size="small" type="number" v-model="item.port" @input="item.port=intNumber(item.port)" placeholder="端口"></el-input>
                </td>
                <td>
                  <el-button size="small" type="info" @click="saveclick2(item)">保存</el-button>
                  <el-button size="small" type="info" @click="test(item)">测试链接</el-button>
                  <el-button size="small" type="danger" :disabled="item.isDefault" @click="handleClose2(item,i)">移除路线</el-button>
                </td>
              </tr>
            </tbody>
          </table>
          <p class="tc pdt5 pdb5">
            <el-button size="small" type="primary" @click="add2">添加</el-button>
          </p>
        </div>
      </div>
    </div>
    <div class="gs_tablestyle1 mgt15">
      <div class="addtable">
        <div class="tabletit"><span>总后台域名：</span></div>
        <div class="tablebox">
          <table>
            <thead>
              <tr>
                <th width="50">默认</th>
                <th>线路名称</th>
                <th>总后台域名</th>
                <th width="100">端口</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,i) in data3" :key="'charge'+i">
                <td>
                  <span class="gs_rido" :class="{'checked':item.isDefault,'disable':item.addself}" @click="changedefault3(item)"></span>
                </td>
                <td>
                  <el-input size="small" v-model="item.name" placeholder="线路名称"></el-input>
                </td>
                <td>
                  <el-input size="small" v-model="item.domainName" placeholder="名称"></el-input>
                </td>
                <td>
                  <el-input size="small" type="number" v-model="item.port" @input="item.port=intNumber(item.port)" placeholder="端口"></el-input>
                </td>
                <td>
                  <el-button size="small" type="info" @click="saveclick3(item)">保存</el-button>
                  <el-button size="small" type="info" @click="test(item)">测试链接</el-button>
                  <el-button size="small" type="danger" :disabled="item.isDefault" @click="handleClose3(item,i)">移除路线</el-button>
                </td>
              </tr>
            </tbody>
          </table>
          <p class="tc pdt5 pdb5">
            <el-button size="small" type="primary" @click="add3">添加</el-button>
          </p>
        </div>
      </div>
    </div>
    <p class="tc mgt15" style="color:red;">提示：必须填写顶级域名且不可带参数，域名设置后即时生效</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data0: [],
      data1: [],
      data2: [],
      data3: []
    };
  },
  methods: {
    /* --------------------------1.充值域名-------------------- */
    // 充值域名list
    async getlist0() {
      this.$api.systemset
        .arealist({
          TypeId: 0
        })
        .then((data) => {
          if (data.status === 200) {
            this.data0 = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 充值域名手动添加充值域名
    add0() {
      this.data0.push({
        domainName: '',
        isDefault: false,
        name: '',
        port: '',
        addself: true
      });
    },
    // 添加充值域名保存
    async save0(data) {
      if (data.name === '') {
        this.$messageError('线路名称不能为空');
        return;
      } else if (data.domainName === '') {
        this.$messageError('充值域名不能为空');
        return;
      } else if (data.port === '') {
        this.$messageError('端口不能为空');
        return;
      }
      this.$api.systemset
        .areaadd({
          id: 0,
          domainName: data.domainName,
          isDefault: true,
          name: data.name,
          port: parseInt(data.port),
          type: 0,
          state: true
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('添加成功！');
            this.getlist0();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 充值域名编辑
    async edit0(data) {
      this.$api.systemset
        .areaedit({
          id: data.id,
          domainName: data.domainName,
          isDefault: data.isDefault,
          name: data.name,
          port: parseInt(data.port),
          type: 0,
          state: data.state
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('编辑成功！');
            this.getlist0();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 添加充值域名保存点击
    saveclick0(data) {
      if (data.addself) {
        this.save0(data);
      } else {
        this.edit0(data);
      }
    },
    // 移除线路
    handleClose0(item, index) {
      if (item.addself) {
        this.data0.splice(index, 1);
      } else {
        this.$confirm('是否确定移除线路')
          .then(() => {
            this.romove0(item);
          })
          .catch(() => {});
      }
    },
    // 充值域名移除线路
    async romove0(item) {
      this.$api.systemset
        .arearemove({
          id: item.id
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('移除成功!');
            this.getlist0();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 充值域名更改默认
    async changedefault0(data) {
      if (data.addself || data.isDefault) {
        return;
      }
      this.$api.systemset
        .areadefault({
          id: data.id
        })
        .then((data) => {
          if (data.status === 200) {
            this.getlist0();
            this.$messageSuccess('更改成功！');
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    /* --------------------------1.商户域名-------------------- */
    // 商户域名list
    async getlist1() {
      this.$api.systemset
        .arealist({
          TypeId: 1
        })
        .then((data) => {
          if (data.status === 200) {
            this.data1 = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 商户域名手动添加商户域名
    add1() {
      this.data1.push({
        domainName: '',
        isDefault: false,
        name: '',
        port: '',
        addself: true
      });
    },
    // 添加商户域名保存
    async save1(data) {
      if (data.name === '') {
        this.$messageError('线路名称不能为空');
        return;
      } else if (data.domainName === '') {
        this.$messageError('商户域名不能为空');
        return;
      } else if (data.port === '') {
        this.$messageError('端口不能为空');
        return;
      }
      this.$api.systemset
        .areaadd({
          id: 0,
          domainName: data.domainName,
          isDefault: true,
          name: data.name,
          port: parseInt(data.port),
          type: 1,
          state: true
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('添加成功！');
            this.getlist1();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 商户域名编辑
    async edit1(data) {
      this.$api.systemset
        .areaedit({
          id: data.id,
          domainName: data.domainName,
          isDefault: data.isDefault,
          name: data.name,
          port: parseInt(data.port),
          type: 1,
          state: data.state
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('编辑成功！');
            this.getlist1();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 添加商户域名保存点击
    saveclick1(data) {
      if (data.addself) {
        this.save1(data);
      } else {
        this.edit1(data);
      }
    },
    // 移除线路
    handleClose1(item, index) {
      if (item.addself) {
        this.data1.splice(index, 1);
      } else {
        this.$confirm('是否确定移除线路')
          .then(() => {
            this.romove1(item);
          })
          .catch(() => {});
      }
    },
    // 商户域名移除线路
    async romove1(item) {
      this.$api.systemset
        .arearemove({
          id: item.id
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('移除成功!');
            this.getlist1();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 商户域名更改默认
    async changedefault1(data) {
      if (data.addself || data.isDefault) {
        return;
      }
      this.$api.systemset
        .areadefault({
          id: data.id
        })
        .then((data) => {
          if (data.status === 200) {
            this.getlist1();
            this.$messageSuccess('更改成功！');
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    /* --------------------------2.IPS统计域名-------------------- */
    // IPS统计域名list
    async getlist2() {
      this.$api.systemset
        .arealist({
          TypeId: 3
        })
        .then((data) => {
          if (data.status === 200) {
            this.data2 = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // IPS统计域名手动添加IPS统计域名
    add2() {
      this.data2.push({
        domainName: '',
        isDefault: false,
        name: '',
        port: '',
        addself: true
      });
    },
    // 添加IPS统计域名保存
    async save2(data) {
      if (data.name === '') {
        this.$messageError('线路名称不能为空');
        return;
      } else if (data.domainName === '') {
        this.$messageError('IPS统计域名不能为空');
        return;
      } else if (data.port === '') {
        this.$messageError('端口不能为空');
        return;
      }
      this.$api.systemset
        .areaadd({
          id: 0,
          domainName: data.domainName,
          isDefault: true,
          name: data.name,
          port: parseInt(data.port),
          type: 3,
          state: true
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('添加成功！');
            this.getlist2();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // IPS统计域名编辑
    async edit2(data) {
      this.$api.systemset
        .areaedit({
          id: data.id,
          domainName: data.domainName,
          isDefault: data.isDefault,
          name: data.name,
          port: parseInt(data.port),
          type: 3,
          state: data.state
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('编辑成功！');
            this.getlist2();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 添加IPS统计域名保存点击
    saveclick2(data) {
      if (data.addself) {
        this.save2(data);
      } else {
        this.edit2(data);
      }
    },
    // 移除线路
    handleClose2(item, index) {
      if (item.addself) {
        this.data1.splice(index, 1);
      } else {
        this.$confirm('是否确定移除线路')
          .then(() => {
            this.romove2(item);
          })
          .catch(() => {});
      }
    },
    // IPS统计域名移除线路
    async romove2(item) {
      this.$api.systemset
        .arearemove({
          id: item.id
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('移除成功!');
            this.getlist2();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // IPS统计域名更改默认
    async changedefault2(data) {
      if (data.addself || data.isDefault) {
        return;
      }
      this.$api.systemset
        .areadefault({
          id: data.id
        })
        .then((data) => {
          if (data.status === 200) {
            this.getlist2();
            this.$messageSuccess('更改成功！');
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    /* --------------------------3.总后台域名-------------------- */
    // 总后台域名list
    async getlist3() {
      this.$api.systemset
        .arealist({
          TypeId: 2
        })
        .then((data) => {
          if (data.status === 200) {
            this.data3 = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 总后台域名手动添加总后台域名
    add3() {
      this.data3.push({
        domainName: '',
        isDefault: false,
        name: '',
        port: '',
        addself: true
      });
    },
    // 添加总后台域名保存
    async save3(data) {
      if (data.name === '') {
        this.$messageError('线路名称不能为空');
        return;
      } else if (data.domainName === '') {
        this.$messageError('总后台域名不能为空');
        return;
      } else if (data.port === '') {
        this.$messageError('端口不能为空');
        return;
      }
      this.$api.systemset
        .areaadd({
          id: 0,
          domainName: data.domainName,
          isDefault: true,
          name: data.name,
          port: parseInt(data.port),
          type: 2,
          state: true
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('添加成功！');
            this.getlist3();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 总后台域名编辑
    async edit3(data) {
      this.$api.systemset
        .areaedit({
          id: data.id,
          domainName: data.domainName,
          isDefault: data.isDefault,
          name: data.name,
          port: parseInt(data.port),
          type: 2,
          state: data.state
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('编辑成功！');
            this.getlist3();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 添加总后台域名保存点击
    saveclick3(data) {
      if (data.addself) {
        this.save3(data);
      } else {
        this.edit3(data);
      }
    },
    // 移除线路
    handleClose3(item, index) {
      if (item.addself) {
        this.data3.splice(index, 1);
      } else {
        this.$confirm('是否确定移除线路')
          .then(() => {
            this.romove3(item);
          })
          .catch(() => {});
      }
    },
    // 总后台域名移除线路
    async romove3(item) {
      this.$api.systemset
        .arearemove({
          id: item.id
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('移除成功!');
            this.getlist3();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 总后台域名更改默认
    async changedefault3(data) {
      if (data.addself || data.isDefault) {
        return;
      }
      this.$api.systemset
        .areadefault({
          id: data.id
        })
        .then((data) => {
          if (data.status === 200) {
            this.getlist3();
            this.$messageSuccess('更改成功！');
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 测试通不通
    async test(data) {
      this.$api.systemset
        .areatest({
          webUrl: data.domainName + ':' + data.port + '/static/checkedpage.html'
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('测试成功！');
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    }
  },
  created() {
    this.getlist0();
    this.getlist1();
    this.getlist2();
    this.getlist3();
  }
};
</script>

<style lang="scss" scoped>
.gs_tablestyle1 {
  .addtable {
    position: relative;
    padding-left: 135px;
    background: #fff;
    .tabletit {
      position: absolute;
      width: 135px;
      height: 100%;
      left: 0;
      top: 0;
      background: #f1f7f9;
      span {
        position: absolute;
        height: 50px;
        line-height: 50px;
        width: 100%;
        text-align: center;
        top: 50%;
        left: 0;
        margin-top: -25px;
      }
    }
    .tablebox {
      table {
        width: 100%;
        th {
          height: 40px;
          font-size: 14px;
          color: #3e3e3e;
          background: #e4eaec;
          font-weight: normal;
          // border: 1px solid #bfbfbf;
        }
        td {
          height: 50px;
          border: 1px solid #e4eaec;
          text-align: center;
          padding: 0 8px;
        }
      }
    }
  }
}
</style>
